import { render, staticRenderFns } from "./StarIcon.vue?vue&type=template&id=3943c612&scoped=true"
import script from "./StarIcon.vue?vue&type=script&lang=js"
export * from "./StarIcon.vue?vue&type=script&lang=js"
import style0 from "./StarIcon.vue?vue&type=style&index=0&id=3943c612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3943c612",
  null
  
)

export default component.exports